import { Recording } from '@goldcast/api/backend';
import moment from 'moment';

import { VideoAsset } from '@/studio/videoLibrary/videoLibraryService';

/**
 * @deprecated Remove this function once we remove old recordings API and start using Video Library only
 */
export function transformServerRecordings(recordings: Recording[] | VideoAsset[]): {
  [key: number]: Recording | VideoAsset;
} {
  const transformedRecordings = {};
  recordings.forEach((recording, index) => {
    transformedRecordings[index] = {
      ...recording,
      id: recording?.id ?? index,
      formattedCreatedTime: moment(recording?.created_at || '')
        .tz(moment.tz.guess())
        .format('MMM D, YYYY, h:mm A z')
    };
  });
  return transformedRecordings;
}
